import * as React from 'react'

import { cn } from '@/lib/utils'

export interface InputProps extends React.ComponentProps<'input'> {
  'aria-describedby'?: string
  'aria-invalid'?: boolean
  'aria-required'?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, 'aria-invalid': ariaInvalid, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-11 w-full rounded-xl border border-lilac-900 bg-white px-4 py-3 text-base transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground text-night-900 placeholder:text-night-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blueviolet-light disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-night-100 disabled:placeholder:text-night-500 min-h-[44px]',
          ariaInvalid && 'border-error focus-visible:border-error focus-visible:ring-error-dark',
          type === 'date' && 'px-0 sm:px-4',
          className
        )}
        aria-invalid={ariaInvalid}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
